import { Switch, Group, Text, Box } from "@mantine/core";
import { useState } from "react";
import _ from "lodash";

import { IconCircleCheck, IconAlertCircle } from "@tabler/icons";
import { FormSectionCard } from "../layout/page";
import { useTranslation } from "react-i18next";

const LicenceCheckList = ({
  form,
  name,

  label,
  readOnly = false,
  title = "Licences Required",

  ...props
}) => {
  const licences = _.get(form.values, name);
  const { t } = useTranslation();
  const allLicences = [
    {
      name: "l1",
      label: "I    -  Principles & Practices of Insurance (保險原則與實踐)",
    },
    { name: "l2", label: "II   -  General Insurance (一般保險)" },
    { name: "l3", label: "III  -  Long Term Insurance (長期保險)" },
    { name: "l4", label: "IV   -  MPF (強積金)" },
    {
      name: "l5",
      label: "V    -  Investment Link Long Term Insurance (投資相連長期保險)",
    },
  ];

  // console.log(form)

  return (
    licences && (
      <>
        {/* {JSON.stringify(props, null, 2) } */}
        {/* {JSON.stringify(licences)} */}
        {/* <Text mt="xl" mb="sm">
          {t(title)}
        </Text> */}
        {allLicences.map((lic) => (
          <Box key={lic.name} mb="sm">
            {!readOnly && (
              <Switch
                key={`licences.${lic.name}`}
                label={lic.label}
                value={licences[lic.name]}
                checked={licences[lic.name]}
                disabled={readOnly}
                {...form.getInputProps(`${name}.${lic.name}`)}
              />
            )}
            {readOnly && (
              <Group>
                {licences[lic?.name] && <IconCircleCheck color="#00b341" />}
                {!licences[lic.name] && <IconAlertCircle color="#ff4500" />}
                <Text> {lic.label}</Text>
              </Group>
            )}
          </Box>
        ))}
      </>
    )
  );
};

export default LicenceCheckList;
